export enum PATHS {
  signUp = '/sign-up',
  login = '/login',
  main = '/',
  courses = '/courses',
  course = '/courses/:groupId/*',
  lesson = '/courses/:groupId/:lessonId/*',
  lessonDescription = 'lessonDescription',
  lessonStudentAttachments = 'lessonAttachments/student',
  lessonTeacherAttachments = 'lessonAttachments/teacher',
  lessonStudentResources = 'lessonResources/student',
  lessonJournal = 'lessonJournal',
  lessonTasks = 'lessonTasks',
  lessonResults = 'lessonResults',
  lessonFinalTest = 'lessonFinalTest',
  lessonWhiteboard = 'lessonWhiteboard',
  // NB: `homework` is taken by the TasksTabs sub-route below — do not reuse it.
  lessonHomework = 'lessonHomework',
  invoices = '/invoices',
  // The diploma CERTIFICATE page — not `graduationProject` above, which is the
  // lesson-tab дипломный проект.
  diplomas = '/diplomas',
  surveys = '/surveys',
  survey = '/surveys/:assignmentId',
  // ═══ Карьерный маршрут (ТЗ 0069) ═══
  //
  // 🔴 Первый сегмент обязан оставаться литералом `career`: `useActiveMenu`
  // сравнивает его со ЗНАЧЕНИЕМ enum `MenuItems`, и переименование сегмента
  // молча гасит подсветку меню на всём разделе.
  //
  // Раньше карьерный домен был разложен по трём корням — `/career` (под гейтом
  // членства), `/growth` (продающий, потому и снаружи) и `/resume`. Аудит
  // владельца: студент не понимал, что это один продукт. Теперь корень один, а
  // гейт членства переехал с МАРШРУТА на РАЗДЕЛЫ: не-участник видит объяснение
  // и CTA вместо 404, и `/career` наконец может быть витриной.
  careerCenter = '/career',
  careerLearning = '/career/learning',
  careerLesson = '/career/learning/:lessonId',
  careerProfile = '/career/profile',
  careerSkills = '/career/skills',
  careerSkill = '/career/skills/:slug',
  careerProfessions = '/career/professions',
  careerProfession = '/career/professions/:code',
  careerJobs = '/career/jobs',
  careerApplications = '/career/applications',
  careerAchievements = '/career/achievements',

  // ═══ Старые адреса — ТОЛЬКО для редиректов (ТЗ 0069) ═══
  //
  // Адреса из писем, закладок и заметок живут вечно, срока снятия у этого
  // блока нет. Префикс `legacy` несущий: имя без пометки приглашает новый код
  // сослаться на старый адрес, и через полгода у экрана снова окажется две
  // точки входа. Список редиректов — `router/legacyRedirects.ts`.
  legacyResume = '/resume',
  legacyGrowth = '/growth',
  legacyGrowthAchievements = '/growth/achievements',
  legacyGrowthProfessions = '/growth/professions',
  legacyGrowthProfession = '/growth/professions/:code',
  legacyGrowthSkills = '/growth/skills',
  legacyGrowthSkill = '/growth/skills/:slug',
  legacyCareerVacancies = '/career/vacancies',
  attachments = '/attachments',
  attachment = '/attachments/:type/:fileId/*',
  homework = 'homework',
  coursework = 'coursework',
  graduationProject = 'graduationProject',
}
